import { mapSuggestionFilterToStatus } from "pages/communication/model/suggestionStatusMapper";
import { applyDateFilter } from "shared/lib/date/dateFilters";
import { toKstDate } from "shared/lib/date/formatKst";

export const defaultStatusOptions = [
  "전체",
  "답변대기",
  "진행 중",
  "답변완료",
];

const hasNoActiveFilters = ({
  condition,
  dateButtonClicked,
  selectedStatus,
  startDate,
  endDate,
  keyword,
  defaultSearchOption,
}) =>
  condition === defaultSearchOption &&
  !keyword &&
  dateButtonClicked.every((clicked) => !clicked) &&
  selectedStatus === defaultStatusOptions[0] &&
  !startDate &&
  !endDate;

export const createInquiryFilter = () => (data, filters) => {
  const { condition, dateButtonClicked, chips, startDate, endDate, keyword } =
    filters;
  const selectedStatus = chips?.status;

  let filteredResults = data;
  const keywordLower = keyword.toLowerCase();

  if (condition === "제목만") {
    filteredResults = filteredResults.filter((item) =>
      item.title?.toLowerCase().includes(keywordLower),
    );
  } else if (condition === "제목+본문") {
    filteredResults = filteredResults.filter(
      (item) =>
        item.title?.toLowerCase().includes(keywordLower) ||
        item.content?.toLowerCase().includes(keywordLower),
    );
  } else if (condition === "본문만") {
    filteredResults = filteredResults.filter((item) =>
      item.content?.toLowerCase().includes(keywordLower),
    );
  } else if (condition === "답변자") {
    filteredResults = filteredResults.filter(
      (item) =>
        item.ansUser &&
        item.ansUser.name &&
        item.ansUser.name.toLowerCase().includes(keywordLower),
    );
  }

  if (selectedStatus === "답변대기") {
    filteredResults = filteredResults.filter((item) => item.status === 0);
  } else if (selectedStatus === "진행 중") {
    filteredResults = filteredResults.filter((item) => item.status === 1);
  } else if (selectedStatus === "답변완료") {
    filteredResults = filteredResults.filter((item) => item.status === 2);
  }

  filteredResults = applyDateFilter({
    data: filteredResults,
    dateButtonClicked,
    startDate,
    endDate,
    getDate: (item) => toKstDate(item.createdAt) ?? new Date(NaN),
  });

  if (
    hasNoActiveFilters({
      condition,
      dateButtonClicked,
      selectedStatus,
      startDate,
      endDate,
      keyword,
      defaultSearchOption: "제목만",
    })
  ) {
    return data;
  }

  return filteredResults;
};

export const createSuggestionFilter = () => (data, filters) => {
  const { condition, dateButtonClicked, chips, startDate, endDate, keyword } =
    filters;
  const selectedStatus = chips?.status;

  let filteredResults = data;
  const keywordLower = keyword.toLowerCase();

  if (condition === "제목만") {
    filteredResults = filteredResults.filter((item) =>
      item.title?.toLowerCase().includes(keywordLower),
    );
  } else if (condition === "답변자") {
    filteredResults = filteredResults.filter(
      (item) =>
        item.ansUser && item.ansUser.toLowerCase().includes(keywordLower),
    );
  }

  const targetStatus = mapSuggestionFilterToStatus(selectedStatus);
  if (targetStatus !== null) {
    filteredResults = filteredResults.filter(
      (item) => item.status === targetStatus,
    );
  }

  filteredResults = applyDateFilter({
    data: filteredResults,
    dateButtonClicked,
    startDate,
    endDate,
    getDate: (item) => toKstDate(item.createdAt) ?? new Date(NaN),
  });

  if (
    hasNoActiveFilters({
      condition,
      dateButtonClicked,
      selectedStatus,
      startDate,
      endDate,
      keyword,
      defaultSearchOption: "제목만",
    })
  ) {
    return data;
  }

  return filteredResults;
};
